var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaycheck1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 4,
    fill: "#D5FBE2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3641 19.7467C33.8625 17.215 31.9841 16.1067 29.3708 16.1067H19.1275C16.0475 16.1067 13.9941 17.6467 13.9941 21.24V27.2484C13.9941 29.8384 15.0558 31.355 16.8058 32.0084C17.0625 32.1017 17.3425 32.1834 17.6341 32.23C18.1008 32.335 18.6025 32.3817 19.1275 32.3817H29.3825C32.4625 32.3817 34.5158 30.8417 34.5158 27.2484V21.24C34.5158 20.6917 34.4691 20.2017 34.3641 19.7467ZM18.4508 26C18.4508 26.4784 18.0541 26.875 17.5758 26.875C17.0975 26.875 16.7008 26.4784 16.7008 26V22.5C16.7008 22.0217 17.0975 21.625 17.5758 21.625C18.0541 21.625 18.4508 22.0217 18.4508 22.5V26ZM24.2491 27.33C22.5458 27.33 21.1691 25.9534 21.1691 24.25C21.1691 22.5467 22.5458 21.17 24.2491 21.17C25.9525 21.17 27.3291 22.5467 27.3291 24.25C27.3291 25.9534 25.9525 27.33 24.2491 27.33ZM31.7858 26C31.7858 26.4784 31.3891 26.875 30.9108 26.875C30.4325 26.875 30.0358 26.4784 30.0358 26V22.5C30.0358 22.0217 30.4325 21.625 30.9108 21.625C31.3891 21.625 31.7858 22.0217 31.7858 22.5V26Z",
    fill: "#00A63E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0174 24.74V30.7483C38.0174 34.3417 35.964 35.8933 32.8724 35.8933H22.629C21.754 35.8933 20.9724 35.765 20.2957 35.5083C19.7474 35.31 19.269 35.0183 18.884 34.645C18.674 34.4467 18.8374 34.1317 19.129 34.1317H29.3724C33.689 34.1317 36.2557 31.565 36.2557 27.26V21.24C36.2557 20.96 36.5707 20.785 36.769 20.995C37.5624 21.835 38.0174 23.06 38.0174 24.74Z",
    fill: "#00A63E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaycheck1);
export default __webpack_public_path__ + "static/media/paycheck1.42cb92485f6af66ebce02286278f2ca9.svg";
export { ForwardRef as ReactComponent };